import type { FC } from 'react';

import { Headline, Icon, Popover } from '@zen/DesignSystem';

import { rejectReasons } from '../helpers';

interface RejectPopoverProps {
  id: string;
  onReject: (id: string, reason: string) => void;
}

export const RejectPopover: FC<RejectPopoverProps> = ({ id, onReject }) => {
  const renderRejectReasons = () => {
    return rejectReasons.map((rejectReason) => (
      <p
        key={rejectReason}
        className="text-left p-2 hover:bg-azure-lightest cursor-pointer"
        onClick={() => onReject(id, rejectReason)}
      >
        {rejectReason}
      </p>
    ));
  };

  const rejectReasonList = () => {
    return (
      <div className="bg-sunset-light p-0.5 rounded-md">
        <div className="flex flex-col rounded-sm py-1 bg-white">
          <Headline level={4} className="m-2">
            Tell us why you are rejecting this suggestion
          </Headline>

          {renderRejectReasons()}
        </div>
      </div>
    );
  };

  return (
    <Popover popover={rejectReasonList} renderInPortal={true} placement="top">
      <Icon className="right-4 cursor-pointer" icon="zicon-close" />
    </Popover>
  );
};
